module.exports = __webpack_public_path__ + "static/media/img76.9398b372.jpg";